var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatrixlabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 89,
    viewBox: "0 0 83 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8794 80.4834H15.238V87.1393H19.0082V88.403H13.8794V80.4834Z",
    fill: "#6432FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.519 88.4072L32.2093 80.3696H32.4367L36.1227 88.4072H34.7115L34.2018 87.2972H30.4358L29.926 88.4072H28.519ZM33.6142 86.0292L32.3314 83.2236L31.0297 86.0292H33.6142Z",
    fill: "#6432FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8499 80.4834C49.3577 80.4625 49.8608 80.5883 50.2991 80.8457C50.6524 81.0611 50.9368 81.3732 51.1184 81.7451C51.2876 82.0988 51.3547 82.4927 51.3122 82.8825C51.2728 83.2756 51.1215 83.6492 50.8762 83.9588C51.169 84.1386 51.4135 84.3874 51.5881 84.6834C51.7602 84.9693 51.8741 85.2864 51.923 85.6165C51.9717 85.9468 51.9582 86.2832 51.883 86.6085C51.8092 86.9353 51.6655 87.2421 51.4617 87.5079C51.2476 87.7834 50.973 88.0061 50.6592 88.1588C50.2916 88.3325 49.8883 88.4176 49.4818 88.4073H46.0991V80.4834H48.8499ZM47.4577 81.7472V83.5923H48.871C49.0158 83.5994 49.1605 83.5765 49.2961 83.525C49.4316 83.4735 49.5551 83.3946 49.6587 83.2932C49.8248 83.1247 49.9185 82.898 49.9199 82.6614C49.9138 82.4237 49.8165 82.1974 49.6482 82.0295C49.5419 81.9297 49.4161 81.8532 49.2787 81.8046C49.1413 81.756 48.9953 81.7365 48.8499 81.7472H47.4577ZM47.4577 84.8603V87.1351H49.4839C49.6967 87.1426 49.9065 87.0837 50.0842 86.9666C50.2369 86.8588 50.3594 86.7138 50.4402 86.5453C50.518 86.3725 50.5582 86.1851 50.5582 85.9956C50.5582 85.8061 50.518 85.6187 50.4402 85.4459C50.3596 85.2772 50.2371 85.1322 50.0842 85.0246C49.9071 84.9059 49.697 84.8461 49.4839 84.854L47.4577 84.8603Z",
    fill: "#6432FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1207 86.5284C63.3488 86.8505 63.6745 87.0905 64.0496 87.213C64.4218 87.3367 64.8115 87.4 65.2038 87.4004C65.3671 87.3997 65.5299 87.3842 65.6904 87.3541C65.8597 87.3265 66.0237 87.2732 66.1769 87.1961C66.3224 87.1253 66.4505 87.0231 66.5519 86.897C66.6525 86.7615 66.7044 86.596 66.6993 86.4273C66.7011 86.2434 66.6342 86.0654 66.5118 85.9281C66.3686 85.7693 66.1999 85.6355 66.0127 85.5321C65.786 85.4021 65.5502 85.2888 65.307 85.193C65.0417 85.0877 64.772 84.9824 64.4961 84.8539C64.2202 84.7254 63.9506 84.6012 63.6873 84.4621C63.4327 84.3291 63.195 84.1657 62.9796 83.9756C62.7753 83.7935 62.6067 83.5749 62.4825 83.3311C62.3533 83.0648 62.2891 82.7718 62.2951 82.4759C62.2848 82.1415 62.3543 81.8095 62.4979 81.5073C62.6415 81.2051 62.855 80.9415 63.1207 80.7382C63.3806 80.5419 63.6739 80.3942 63.9864 80.3022C64.3194 80.2039 64.6649 80.1543 65.0122 80.1548C65.5303 80.1541 66.0429 80.2602 66.5182 80.4665C66.9935 80.6702 67.4269 80.9602 67.7967 81.3217L66.9015 82.3179C66.6465 82.0595 66.3449 81.8515 66.0127 81.705C65.6803 81.5617 65.3214 81.4899 64.9595 81.4944C64.7924 81.4934 64.6256 81.5111 64.4624 81.547C64.3133 81.5783 64.1707 81.6353 64.0412 81.7155C63.917 81.7955 63.8143 81.9047 63.7421 82.0336C63.6615 82.1843 63.6222 82.3536 63.6283 82.5244C63.6303 82.6398 63.6615 82.7529 63.719 82.8531C63.7764 82.9532 63.8583 83.0372 63.9569 83.0973C64.2117 83.2698 64.4834 83.4159 64.7678 83.5333C65.0922 83.6737 65.4433 83.819 65.821 83.9693C66.19 84.1159 66.5429 84.3001 66.8741 84.519C67.1932 84.7294 67.4698 84.9981 67.6893 85.311C67.9168 85.6542 68.0317 86.0599 68.0178 86.4715C68.0256 86.8235 67.9351 87.1707 67.7567 87.4741C67.5858 87.754 67.3584 87.995 67.089 88.1819C66.8084 88.375 66.4961 88.5176 66.1664 88.6031C65.8325 88.6928 65.4885 88.7388 65.1428 88.74C64.8482 88.7397 64.5542 88.7129 64.2644 88.66C63.9752 88.6086 63.6927 88.5253 63.4219 88.4114C63.1557 88.3008 62.9033 88.1595 62.67 87.9902C62.4296 87.8115 62.2168 87.5986 62.0381 87.3583L63.1207 86.5284Z",
    fill: "#6432FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2963 68.4545L10.2 72.7282L7.08063 68.4566C6.97532 68.7747 6.8995 68.9853 6.83631 69.198C6.3666 70.803 5.88426 72.408 5.43773 74.0214C5.33663 74.3858 5.20393 74.5333 4.80584 74.5206C3.87276 74.4932 2.93757 74.5206 1.91602 74.5206L5.79159 61.2868L10.1937 67.3403L14.6022 61.2742C15.9123 65.75 17.1845 70.089 18.4757 74.5017C17.4014 74.5017 16.3946 74.5206 15.3878 74.4827C15.2467 74.4827 15.0424 74.2194 14.9876 74.0425C14.4632 72.3301 13.964 70.6092 13.4564 68.8926C13.4227 68.7831 13.3742 68.6778 13.2963 68.4545Z",
    fill: "#6432FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6875 61.2995C48.6253 61.2995 50.5146 61.2995 52.404 61.2995C53.1238 61.2702 53.8448 61.2843 54.5629 61.3416C55.5212 61.4444 56.4183 61.8623 57.1135 62.5297C57.8088 63.1972 58.2629 64.0764 58.4048 65.0297C58.6828 67.0539 57.6739 68.8632 55.7867 69.7246L55.3464 69.9247C56.3743 71.4286 57.3874 72.9157 58.468 74.5017C57.2716 74.5017 56.1742 74.5143 55.0768 74.4869C54.9336 74.4869 54.7609 74.289 54.6556 74.1436C53.9205 73.0905 53.198 72.0247 52.4735 70.9652C52.0649 70.367 51.7721 69.5961 50.6873 69.9774C51.037 69.0022 51.3192 68.1618 51.6541 67.334C51.6941 67.2308 51.9364 67.1634 52.088 67.1592C52.7325 67.1381 53.375 67.1592 54.0195 67.1423C54.862 67.1107 55.4939 66.5104 55.4939 65.7206C55.4967 65.5297 55.4618 65.3402 55.3914 65.1628C55.3209 64.9854 55.2162 64.8236 55.0832 64.6867C54.9502 64.5498 54.7915 64.4404 54.6162 64.3648C54.4409 64.2892 54.2525 64.2489 54.0616 64.2462C52.602 64.2062 51.1423 64.2335 49.5942 64.2335V74.4764H46.6875V61.2995Z",
    fill: "#6432FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7422 61.3035C68.9154 61.3035 70.0002 61.2888 71.0828 61.3183C71.2239 61.3183 71.3924 61.5289 71.4935 61.67C72.2539 62.7779 73.0016 63.8942 73.8104 65.0927L74.7035 63.7721C75.1606 63.0939 75.6408 62.4283 76.0705 61.7332C76.1506 61.5813 76.2753 61.4576 76.4278 61.3785C76.5802 61.2995 76.7532 61.2689 76.9235 61.2909C77.8714 61.3162 78.8192 61.2909 79.8892 61.2909C77.8756 64.3008 75.9294 67.2138 73.9916 70.1268L74.08 70.2426C74.8214 70.032 75.5671 69.8382 76.3022 69.6107C76.6518 69.5012 76.8477 69.5644 77.0583 69.8887C78.0462 71.4011 79.0698 72.8902 80.1504 74.4931C78.9456 74.4931 77.8461 74.5057 76.7487 74.4762C76.6097 74.4762 76.4496 74.2656 76.3485 74.1119C75.506 72.8902 74.6909 71.6601 73.821 70.3669C73.0206 71.5548 72.2286 72.6838 71.504 73.838C71.1881 74.3393 70.8406 74.55 70.2403 74.512C69.3683 74.4552 68.4899 74.4973 67.5337 74.4973C67.6495 74.2993 67.7233 74.1519 67.8138 74.015C69.1092 72.0919 70.3877 70.1562 71.7126 68.2543C72.0053 67.833 71.9527 67.5718 71.6915 67.1906C70.4783 65.4255 69.2882 63.6415 68.094 61.8617C67.9781 61.7142 67.8897 61.5478 67.7422 61.3035Z",
    fill: "#6432FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.755 74.5036C32.6892 74.5036 31.7161 74.5246 30.7451 74.4825C30.6328 74.4554 30.528 74.4034 30.4384 74.3305C30.3487 74.2577 30.2765 74.1657 30.227 74.0613C30.1693 73.8991 30.0572 73.7619 29.9097 73.6732C29.7622 73.5845 29.5885 73.5496 29.4182 73.5747C28.1944 73.6021 26.9707 73.5852 25.6669 73.5852C26.0102 72.6332 26.3177 71.7549 26.6568 70.8892C26.7041 70.8265 26.7647 70.7751 26.8343 70.7387C26.9039 70.7023 26.9807 70.6817 27.0591 70.6786C27.4804 70.6491 27.9016 70.668 28.4261 70.668C27.8827 69.6149 27.3961 68.6797 26.8738 67.6708L24.4642 72.2793C24.1482 72.8838 23.8197 73.4799 23.5248 74.095C23.4804 74.2309 23.3902 74.3473 23.2696 74.4241C23.149 74.501 23.0054 74.5335 22.8634 74.5162C21.9366 74.4888 21.0099 74.5162 19.9946 74.5162C22.2947 70.093 24.5547 65.7477 26.8717 61.2866C29.1717 65.7077 31.4402 70.0572 33.755 74.5036Z",
    fill: "#6432FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9345 74.4762H37.0025V64.2439H32.6572V61.333H44.2208V64.2165H39.9345V74.4762Z",
    fill: "#6432FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4039 74.4868H61.5625V61.3289H64.4039V74.4868Z",
    fill: "#6432FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.3268C2.00097 3.37849 2.96565 2.46646 4.91397 0.307518C8.21452 16.0331 11.2686 30.8129 14.5692 46.549C35.4067 31.1731 57.1604 15.9025 77.8273 0C74.5626 14.5165 70.8766 31.7354 67.7972 46.233C66.584 45.3126 65.9184 44.8639 64.4777 43.7055C66.8999 29.1721 67.1379 27.4871 69.5433 14.5165C50.7868 27.3817 31.8408 40.4049 12.2165 53.8325C7.68795 37.869 4.52852 21.2988 0 5.3268Z",
    fill: "url(#paint0_linear_45_1654)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1807 53.7714L17.0251 56.3684L41.3191 40.3606L65.6804 56.2294L70.3142 54.0515L46.6543 37.2012L67.9973 22.8089C68.514 20.0469 69.0294 17.2855 69.5433 14.5249L12.1807 53.7714Z",
    fill: "url(#paint1_linear_45_1654)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6904 14.4365C20.3657 19.7718 28.7277 25.3008 36.403 30.6381C34.8823 31.7839 33.292 32.8602 31.7692 34.0082C26.1307 30.2863 19.7528 26.2149 14.1122 22.4931C13.5982 19.7317 13.2044 17.1979 12.6904 14.4365Z",
    fill: "url(#paint2_linear_45_1654)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5635 26.8804C29.8399 18.2804 16.604 8.83792 4.88037 0.23584C7.93449 15.0515 11.4099 31.6553 14.5693 46.5489C16.3596 45.2051 16.8504 44.7838 18.3248 43.7665C16.5345 34.6041 14.4808 23.5988 12.6905 14.4364C22.2046 21.1934 28.8731 25.4776 36.4031 30.638C38.72 28.9003 39.8258 28.1442 41.5635 26.8804Z",
    fill: "url(#paint3_linear_45_1654)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6548 37.2014C48.5841 35.9102 49.7089 35.1667 51.4297 34.0083C57.6938 38.7305 62.4288 42.2417 67.7998 46.1742C70.9319 30.4655 74.283 15.1738 77.8279 0.00854492C80.0921 2.53609 81.0884 3.58924 82.5628 5.06364C78.6451 21.0082 74.3883 37.8944 70.3147 54.0412C62.9785 48.8913 53.991 42.3618 46.6548 37.2014Z",
    fill: "url(#paint4_linear_45_1654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_1654",
    x1: 0,
    y1: 26.9247,
    x2: 77.8273,
    y2: 26.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DECFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D59EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C752FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C237FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BF24FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#BD19FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BC15FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DA94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C83FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A400D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_1654",
    x1: 12.1807,
    y1: 35.4467,
    x2: 70.3142,
    y2: 35.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1F006A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2A007F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C00A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4300B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3D00C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3700D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3300E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3200E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2B00D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2400B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1F00A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1C0098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_1654",
    x1: 12.6904,
    y1: 24.2223,
    x2: 36.403,
    y2: 24.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4500AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4400AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3C00C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3700DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3300E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3200E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_1654",
    x1: 4.88037,
    y1: 23.3924,
    x2: 41.5635,
    y2: 23.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#926AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5D2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3200E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_1654",
    x1: 46.6548,
    y1: 27.0301,
    x2: 82.5628,
    y2: 27.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4500AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4D0BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#662DCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7948E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#875BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8F66FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#926AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5D2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3200E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8255FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixlabs);
export default __webpack_public_path__ + "static/media/matrixlabs.ea823635258ecc10ad5318eefd06a56c.svg";
export { ForwardRef as ReactComponent };